import fromObjectToValues from 'utils/converters/object/fromObjectToValues.util';

// NOTE: result from beSCustomPermissions

// just a helper to reduce noise
const p = (index, snake, camel) => Object.freeze({ index, snake, camel });

const PERM = {
  //
  // NOTE: avoid using these, they are for testing only

  none: Object.freeze({ index: -1, snake: 'none_none:none', camel: 'none' }),

  //
  // NOTE: the actual BE related permissions start here

  canViewDailyCashupPersonal: p(5, 'can_view_daily_cashup:personal', 'canViewDailyCashupPersonal'),
  canViewDailyCashupAllStaff: p(6, 'can_view_daily_cashup:all_staff', 'canViewDailyCashupAllStaff'),

  canViewKpiReportsPersonal: p(8, 'can_view_kpi_reports:personal', 'canViewKpiReportsPersonal'),
  canViewKpiReportsAllStaff: p(9, 'can_view_kpi_reports:all_staff', 'canViewKpiReportsAllStaff'),

  canEditStaffPermissions: p(10, 'can_edit_staff_permissions:true', 'canEditStaffPermissions'),

  canEditStaffCommissions: p(15, 'can_edit_staff_commissions:true', 'canEditStaffCommissions'),

  canEditKpisPersonal: p(13, 'can_edit_kpis:personal', 'canEditKpisPersonal'),
  canEditKpisAllStaff: p(14, 'can_edit_kpis:all_staff', 'canEditKpisAllStaff'),

  canViewCalendarAllStaff: p(17, 'can_view_calendar:all_staff', 'canViewCalendarAllStaff'),
  canViewCalendarPersonal: p(18, 'can_view_calendar:personal', 'canViewCalendarPersonal'),
  canViewCalendarNoAccess: p(19, 'can_view_calendar:no_access', 'canViewCalendarNoAccess'),

  // Creating Appointments
  canCreateAppointmentAllStaff: p(22, 'can_create_appointment:all_staff', 'canCreateAppointmentAllStaff'),
  canCreateAppointmentPersonal: p(21, 'can_create_appointment:personal', 'canCreateAppointmentPersonal'),
  canCreateAppointmentNoAccess: p(20, 'can_create_appointment:no_access', 'canCreateAppointmentNoAccess'),

  // Moving Appointments
  canMoveAppointmentAllStaff: p(25, 'can_move_appointment:all_staff', 'canMoveAppointmentAllStaff'),
  canMoveAppointmentPersonal: p(24, 'can_move_appointment:personal', 'canMoveAppointmentPersonal'),
  canMoveAppointmentNoAccess: p(23, 'can_move_appointment:no_access', 'canMoveAppointmentNoAccess'),

  // Deleting Appointments
  canDeleteAppointmentAllStaff: p(28, 'can_delete_appointment:all_staff', 'canDeleteAppointmentAllStaff'),
  canDeleteAppointmentPersonal: p(27, 'can_delete_appointment:personal', 'canDeleteAppointmentPersonal'),
  canDeleteAppointmentNoAccess: p(26, 'can_delete_appointment:no_access', 'canDeleteAppointmentNoAccess'),

  // Editing Appointment Price/Duration
  canEditAppointmentPrice: p(29, 'can_edit_appointment_price:true', 'canEditAppointmentPrice'),
  canEditAppointmentDuration: p(31, 'can_edit_appointment_duration:true', 'canEditAppointmentDuration'),

  // Time-off
  canCreateTimeOff: p(35, 'can_create_time_off:all_staff', 'canCreateTimeOff'),
  canCreateTimeOffNoAccess: p(33, 'can_create_time_off:no_access', 'canCreateTimeOffNoAccess'),
  canCreateTimeOffPersonal: p(34, 'can_create_time_off:personal', 'canCreateTimeOffPersonal'),
  canDeleteTimeOff: p(38, 'can_delete_time_off:all_staff', 'canDeleteTimeOff'),
  canDeleteTimeOffNoAccess: p(36, 'can_delete_time_off:no_access', 'canDeleteTimeOffNoAccess'),
  canDeleteTimeOffPersonal: p(37, 'can_delete_time_off:personal', 'canDeleteTimeOffPersonal'),
  canEditTimeOffDuration: p(41, 'can_edit_time_off_duration:all_staff', 'canEditTimeOffDuration'),
  canEditTimeOffDurationNoAccess: p(39, 'can_edit_time_off_duration:no_access', 'canEditTimeOffDurationNoAccess'),
  canEditTimeOffDurationPersonal: p(40, 'can_edit_time_off_duration:personal', 'canEditTimeOffDurationPersonal'),

  // Client Bills
  canApplyDiscountAtCheckout: p(42, 'can_apply_discount_at_checkout:true', 'canApplyDiscountAtCheckout'),
  canChangePriceAtCheckout: p(44, 'can_change_price_at_checkout:true', 'canChangePriceAtCheckout'),
  canVoidTransaction: p(46, 'can_void_transaction:true', 'canVoidTransaction'),

  // Account Settings
  canEditBusinessInfoHours: p(48, 'can_edit_business_info_hours:true', 'canEditBusinessInfoHours'),
  canEditBillingInfo: p(50, 'can_edit_billing_info:true', 'canEditBillingInfo'),
  canEditCalendarSettings: p(52, 'can_edit_calendar_settings:true', 'canEditCalendarSettings'),
  canEditStaff: p(54, 'can_edit_staff:true', 'canEditStaff'),
  canEditServices: p(56, 'can_edit_services:true', 'canEditServices'),

  // Managing Appointments (slideout enforcement)
  canManageSlideoutAppointmentsAllStaff: p(58, 'can_manage_appointments:all_staff', 'canManageSlideoutAppointmentsAllStaff'),
  canManageSlideoutAppointmentsPersonal: p(59, 'can_manage_appointments:personal', 'canManageSlideoutAppointmentsPersonal'),
  canManageSlideoutAppointmentsNoAccess: p(60, 'can_manage_appointments:no_access', 'canManageSlideoutAppointmentsNoAccess'),

  // Client Management
  canViewClientDetails: p(61, 'can_view_client_details:true', 'canViewClientDetails'),
  canEditClients: p(63, 'can_edit_clients:true', 'canEditClients'),
  canDeleteClients: p(65, 'can_delete_clients:true', 'canDeleteClients'),

  // Services Bookable Online
  canAmendOnlineServicesAllStaff: p(67, 'can_amend_online_services:all_staff', 'canAmendOnlineServicesAllStaff'),
  canAmendOnlineServicesPersonal: p(68, 'can_amend_online_services:personal', 'canAmendOnlineServicesPersonal'),
  canAmendOnlineServicesNoAccess: p(69, 'can_amend_online_services:no_access', 'canAmendOnlineServicesNoAccess'),

  // Online Booking Settings
  canEditAvailability: p(70, 'can_edit_availability:true', 'canEditAvailability'),
  canEditAvailabilityNoAccess: p(71, 'can_edit_availability:false', 'canEditAvailabilityNoAccess'),
  canManageOnlineDepositSettingsAllStaff: p(72, 'can_manage_online_deposit_settings:all_staff', 'canManageOnlineDepositSettingsAllStaff'),
  canManageOnlineDepositSettingsNoAccess: p(73, 'can_manage_online_deposit_settings:no_access', 'canManageOnlineDepositSettingsNoAccess'),

  // Payments
  canManageBusinessStripeAccount: p(74, 'can_manage_business_stripe_account:true', 'canManageBusinessStripeAccount'),
};

for (const perm of fromObjectToValues(PERM)) {
  PERM[perm.index] = perm;
  PERM[perm.camel] = perm;
  PERM[perm.snake] = perm;
}

// OK, we no longer allow adding permissions to this object
Object.freeze(PERM);

export default PERM;
